package org.teddapp.project.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

/**
 * Paliers de compétence, tels que le noyau les nomme. L'interface ne connaît ni les
 * seuils ni la façon de les franchir : elle nomme et colore ce qu'on lui annonce.
 *
 * Couleurs sémantiques distinctes de l'accent ; le débutant est gris, pas rouge :
 * le seuil de frustration n'est pas une faute.
 */
enum class TeddTier(val label: String) {
    Beginner("Débutant"),
    Bronze("Bronze"),
    Silver("Argent"),
    Gold("Or");

    companion object {
        /**
         * Traduit le palier annoncé par le noyau. C'est lui qui tient la règle de
         * Kaufman ; l'interface ne fait que nommer et colorer ce qu'il annonce.
         *
         * Renvoie null pour une valeur inconnue : mieux vaut ne rien afficher que
         * de deviner un palier.
         */
        fun fromCore(palier: String?): TeddTier? = when (palier?.uppercase()) {
            "DEBUTANT", "DÉBUTANT" -> Beginner
            "BRONZE" -> Bronze
            "ARGENT" -> Silver
            "OR" -> Gold
            else -> null
        }
    }
}

@Composable
fun tierColor(tier: TeddTier): Color = when (tier) {
    TeddTier.Beginner -> TeddTokens.InkMuted
    TeddTier.Bronze -> TeddTokens.Bronze
    TeddTier.Silver -> TeddTokens.Argent
    TeddTier.Gold -> TeddTokens.Or
}

@Composable
fun TeddTierBadge(tier: TeddTier, modifier: Modifier = Modifier) {
    Text(
        text = tier.label.uppercase(),
        color = TeddTokens.OnAction,
        fontSize = 9.sp,
        fontWeight = FontWeight.Bold,
        letterSpacing = 0.8.sp,
        modifier = modifier
            .clip(RoundedCornerShape(TeddTokens.RXs))
            .background(tierColor(tier), RoundedCornerShape(TeddTokens.RXs))
            .padding(horizontal = 7.dp, vertical = 2.dp),
    )
}
